export default __webpack_public_path__ + "static/media/twitter_icon.01f08e23.svg";